<template>
  <div id="simple-calendar-app">
    <div class="vx-card org-card no-scroll-content"> 
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="simpleCalendarEvents"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter justify-between">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
              <vs-button class="border-radius-6px" icon-pack="feather" icon="icon-plus" @click="promptAddNewEvent(new Date())">Add Event</vs-button>
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <!-- <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div> -->
          </div>

          <div class="vx-row sm:flex hidden mt-base">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <!-- <div class="flex flex-wrap sm:justify-start justify-center">
                  <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                      <span>{{ label.text }}</span>
                  </div>
                  <div class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                      <span>None</span>
                  </div>
              </div> -->
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

    <!-- ADD EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="Add Event"
        accept-text= "Add Event"
        @accept="addEvent"
        :is-valid="validForm"
        :active.sync="activePromptAddEvent">

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <div class="mb-base">
              <small>Event Title</small>
              <vs-input name="event-name" v-validate="'required'" class="w-full" v-model="title"></vs-input>
            </div>

            <div class="mb-base">
              <small>Board</small>
              <v-select
                class="w-full"
                name="all-boards"
                v-model="boardSelected"
                :options="allBoards"
              />
            </div>

            <div>
              <small>Event Attendees</small>
              <v-select
                class="w-full"
                multiple
                name="event-attendees"
                v-model="eventAttendees"
                :options="attendeeEmailList"
              />
            </div>

            <!-- <div class="calendar__label-container flex">
              <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>

              <vs-dropdown vs-custom-content vs-trigger-click class="ml-auto my-2 cursor-pointer">

                  <feather-icon icon="TagIcon" svgClasses="h-5 w-5" class="cursor-pointer" @click.prevent></feather-icon>

                  <vs-dropdown-menu style="z-index: 200001">
                          <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                              <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                              <span>{{ label.text }}</span>
                          </vs-dropdown-item>

                          <vs-dropdown-item @click="labelLocal = 'none'">
                              <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                              <span>None</span>
                          </vs-dropdown-item>
                  </vs-dropdown-menu>
              </vs-dropdown>

            </div> -->
          </div>
          <div class="vx-col w-full lg:w-1/2">
                <div class="mb-base">
                    <small class="date-label">Start Date</small>
                    <!-- <datepicker :language="$vs.rtl ? langHe : langEn" name="start-date" v-model="startDate" :disabled="disabledFrom"></datepicker> -->
                    <div>
                      <flat-pickr class="w-full" :config="configdateTimePicker" v-model="startDate" placeholder="Start Date Time" />
                    </div>
                </div>
                <div class="mb-base">
                    <small class="date-label">End Date</small>
                    <!-- <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesTo" name="end-date" v-model="endDate"></datepicker> -->
                    <div>
                      <flat-pickr class="w-full" :config="configdateTimePicker" v-model="endDate" placeholder="End Date Time" />
                    </div>
                </div>
                <div>
                  <small class="date-label">Event URL</small>
                  <vs-input name="event-url" v-validate="'url'" class="w-full" v-model="url" :color="!errors.has('event-url') ? 'success' : 'danger'"></vs-input>
                </div>
          </div>
        </div>

        

        

    </vs-prompt>

    <!-- EDIT EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="Edit Event"
        accept-text= "Submit"
        cancel-text = "Remove"
        button-cancel = "border"
        @cancel="removeEvent"
        @accept="editEvent"
        :is-valid="validForm"
        :active.sync="activePromptEditEvent">

        <!-- <div class="calendar__label-container flex">

            <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>

            <vs-dropdown vs-custom-content class="ml-auto my-2 cursor-pointer">

                <feather-icon icon="TagIcon" svgClasses="h-5 w-5" @click.prevent></feather-icon>

                <vs-dropdown-menu style="z-index: 200001">
                        <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                            <span>{{ label.text }}</span>
                        </vs-dropdown-item>

                        <vs-dropdown-item @click="labelLocal = 'none'">
                            <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                            <span>None</span>
                        </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

        </div> -->

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <div class="mb-base">
              <small>Event Title</small>
              <vs-input name="event-name" v-validate="'required'" class="w-full" v-model="title"></vs-input>
            </div>

            <div class="mb-base">
              <small>Board</small>
              <v-select
                class="w-full"
                name="all-boards"
                v-model="boardSelected"
                :options="allBoards"
              />
            </div>

            <div>
              <small>Event Attendees</small>
              <v-select
                class="w-full"
                multiple
                name="event-attendees"
                v-model="eventAttendees"
                :options="attendeeEmailList"
              />
              <div class="my-4">
                <vs-chip v-for="(i, index) in eventAttendees" :key="index">{{i}}</vs-chip>
              </div>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <div class="mb-base">
                <small class="date-label">Start Date</small>
                <!-- <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesFrom" name="start-date" v-model="startDate"></datepicker> -->
                <div>
                  <flat-pickr class="w-full" :config="configdateTimePicker" v-model="startDate" placeholder="Start Date"  />
                </div>
            </div>
            <div class="mb-base">
                <small class="date-label">End Date</small>
                <!-- <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesTo" name="end-date" v-model="endDate"></datepicker> -->
                <div>
                  <flat-pickr class="w-full" :config="configdateTimePicker" v-model="endDate" placeholder="End Date" />
                </div>
            </div>
            <div>
              <small>Event URL</small>
              <vs-input name="event-url" v-validate="'url'" class="w-full" v-model="url" :color="!errors.has('event-url') ? 'success' : 'danger'"></vs-input>
            </div>
          </div>
        </div>

        

    </vs-prompt>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
// import moduleCalendar from '@/store/calendar/moduleCalendar.js'
require('vue-simple-calendar/static/css/default.css')

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import vSelect from "vue-select";
import _ from 'lodash';

import moment from 'moment';
import uuid4 from 'uuid';

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    flatPickr,
    vSelect
  },
  data () {
    return {
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      eventAttendees: [],
      attendeeEmailList: [],
      allBoards: [],
      boardSelected: null,
      startDate: '',
      endDate: '',
      labelLocal: 'none',

      langHe: he,
      langEn: en,

      url: '',
      calendarView: 'month',

      activePromptAddEvent: false,
      activePromptEditEvent: false,

      calendarViewTypes: [
        {
          label: 'Month',
          val: 'month'
        },
        {
          label: 'Week',
          val: 'week'
        },
        {
          label: 'Year',
          val: 'year'
        }
      ],

      datetime: null,
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
      }
    }
  },
  computed: {
    simpleCalendarEvents () {
      return this.$store.state.planner.events
    },
    formattedStartDate() {
      return moment(this.startDate).format()
    },
    formattedEndDate() {
      return moment(this.endDate).format()
    },
    validForm () {
      return this.title !== '' 
        && this.startDate !== '' 
        && this.endDate !== '' 
        && moment(this.formattedEndDate).isAfter(moment(this.formattedStartDate)) 
        && !this.errors.has('event-url')
        && !_.isEmpty(this.boardSelected)
        && !_.isEmpty(this.eventAttendees)
    },
    disabledDatesTo () {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom () {
      return { from: new Date(this.endDate) }
    },
    calendarLabels () {
      return this.$store.state.calendar.eventLabels
    },
    labelColor () {
      return (label) => {
        if      (label === 'business') return 'success'
        else if (label === 'work')     return 'warning'
        else if (label === 'personal') return 'danger'
        else if (label === 'none')     return 'primary'
      }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    _allBoards() {
      return this.$store.state.boards.allBoards;
    }
  },
  watch: {
    _allBoards(newVal) {
      this.allBoards = _.map(newVal, (board) => { return { value: board._id, label: board.title } })
    },
    orgData(newVal) {
      if(this.userData && this.userData._id) {
        this.$store.dispatch('planner/fetchEvents', { userId: this.userData._id, organizationId: newVal._id });
        this.$store.dispatch("boards/fetchAllBoards", newVal._id);
      }
    },
    userData(newVal) {
      if(this.orgData && this.orgData._id) {
        this.$store.dispatch('planner/fetchEvents', { userId: newVal._id, organizationId: this.orgData._id });
        this.$store.dispatch("boards/fetchAllBoards", this.orgData._id);
      }
    },
    boardSelected(newVal) {
      this.$store.dispatch('boards/fetchAllBoardUsers', newVal.value).then(res => {
        console.log(res);
        this.attendeeEmailList = _.map(res.data, (boardUser) => { 
          return { 
            label: `${boardUser.userData.firstName} ${boardUser.userData.lastName}`, 
            value: boardUser.userData.email,
            userId: boardUser.userData._id,
            boardUserId: boardUser._id }
        });
      }).catch(err => {throw err});
    }
  },
  methods: {
    addEvent () {
      const obj = { 
        icsUid: uuid4(),
        title: this.title, 
        startDate: this.formattedStartDate, 
        endDate: this.formattedEndDate, 
        label: this.labelLocal, 
        eventURL: this.url,
        userId: this.userData._id,
        organizationId: this.orgData._id,
        boardId: this.boardSelected.value,
        eventAttendees: _.map(this.eventAttendees, (ea) => { return { userId: ea.userId, boardUserId: ea.boardUserId, email: ea.value } }),
        organizer: {
          name: `${this.userData.firstName} ${this.userData.lastName}`,
          email: this.userData.email
        },
        attendees: _.map(this.eventAttendees, (ea) => { return { name: ea.label, email: ea.value } }),
      };
      obj.classes = `event-${  this.labelColor(this.labelLocal)}`
      this.$store.dispatch('planner/addEvent', obj)
    },
    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
    },
    clearFields () {
      this.title = this.endDate = this.url = '';
      this.id = 0;
      this.labelLocal = 'none';
      this.boardSelected = {};
      this.eventAttendees = [];
    },
    promptAddNewEvent (date) {
      this.disabledFrom = false
      this.addNewEventDialog(date)
    },
    addNewEventDialog (date) {
      this.clearFields()
      this.startDate = date
      this.endDate = date
      this.activePromptAddEvent = true
    },
    openAddNewEvent (date) {
      this.disabledFrom = true
      this.addNewEventDialog(date)
    },
    openEditEvent (event) {
      const e = this.$store.getters['planner/getEvent'](event.originalEvent._id)
      console.log(e);
      this.id = e._id
      this.title = e.title
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.url = e.url
      this.labelLocal = e.label
      this.activePromptEditEvent = true
    },
    editEvent () {
      const obj = { _id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = `event-${  this.labelColor(this.labelLocal)}`
      this.$store.dispatch('planner/editEvent', obj)
    },
    removeEvent () {
      this.$store.dispatch('planner/removeEvent', this.id)
    },
    eventDragged (event, date) {
      this.$store.dispatch('planner/eventDragged', {event, date})
    }
  },
  created () {
    // this.$store.registerModule('calendar', moduleCalendar)
    if(this.userData && this.orgData) {
      this.$store.dispatch('planner/fetchEvents', { userId: this.userData._id, organizationId: this.orgData._id });
      this.$store.dispatch("boards/fetchAllBoards", this.orgData._id);
    }
    // this.$store.dispatch('calendar/fetchEventLabels')
  },
  beforeDestroy () {
    // this.$store.unregisterModule('calendar')
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>

<style scoped>
.calendar-event-dialog >>> .vs-dialog {
  min-width: 800px!important;
}
</style>